import { Field as FormField, Textarea } from '../../../libs/gs-component-form';
import { Content } from '../../../libs/gs-component-right-rail';
import { FormBlockColumn } from '@xo-union/tk-component-form-grid';
import { Field as FormikField } from 'formik';
import React from 'react';
import * as Yup from 'yup';

import { Maybe, QuestionItemsFragment } from '../../../generated/graphql';
import { SharedFormProps } from '../../../helpers/useManageItem';
import { Footer } from '../../FormComponents';
import { DeleteOrDiscard } from '../DeleteOrDiscard';
import styles from '../HeadlineItem/index.scss';
import { useAiTextExperimentContext } from '../../../context/AiTextExperimentContext';

export const validationSchema = Yup.object().shape({
  question: Yup.string().required('Question Text cannot be blank'),
  answer: Yup.string().required('Answer Text cannot be blank'),
});

export interface InitialValues {
  question?: string | null;
  answer?: string | null;
}

export const initialValues = (item?: Maybe<QuestionItemsFragment>): InitialValues => ({
  question: item?.question || '',
  answer: item?.answer || '',
});

const Form: React.FC<SharedFormProps> = ({ loading, updating, submitForm, isNew, discardOrDelete, close }) => {
  const { showAiButton } = useAiTextExperimentContext();
  return (
    <>
      <Content className={styles.content} loading={loading}>
        <FormBlockColumn>
          <FormikField
            component={FormField}
            showAiButton={showAiButton}
            name="question"
            label="Question Text"
            data-testid="question-field"
          />
        </FormBlockColumn>
        <FormBlockColumn>
          <FormikField
            component={Textarea}
            showAiButton={showAiButton}
            name="answer"
            label="Answer Text"
            data-testid="answer-field"
          />
        </FormBlockColumn>
        <DeleteOrDiscard onClick={discardOrDelete} isNew={isNew}>
          Delete question
        </DeleteOrDiscard>
      </Content>
      <Footer primaryOnClick={submitForm} showSpinner={updating} useSaveAndPreview={true} secondaryOnClick={close} />
    </>
  );
};

export default Form;
